<template>
  <div class='encode-rule-container'>
    <div class="left-container">
      <CompanySelect v-if="!isComponent"
                     @choose="choosedCompany"></CompanySelect>
      <EncodeTree :param="getEncodeTreeParam"
                  :selectedNode.sync="curNode"
                  :encodeTree="treeData"></EncodeTree>
    </div>
    <div class="table-container">
      <el-table v-show="curNode.resolve_type!=='2'"
                :highlight-current-row="true"
                :data="encodeRuleList.list"
                border
                class="encode-rule-table">
        <el-table-column prop="rule_name"
                         label="规则名称">
        </el-table-column>
        <el-table-column prop="sources_data_name"
                         label="数据来源">
        </el-table-column>
        <el-table-column prop="para_value"
                         label="参数值">
        </el-table-column>
        <el-table-column prop="start_num"
                         label="开始位">
        </el-table-column>
        <el-table-column prop="end_num"
                         label="截止位">
        </el-table-column>
        <el-table-column prop="fill_style_name"
                         label="填充方式">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editRuleSection(scope.row,'update')"
                       type="text">修改</el-button>
            <el-button @click="deleteRuleSection(scope.row)"
                       type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-show="curNode.resolve_type==='2'"
                :highlight-current-row="true"
                :data="flowList.list"
                border
                class="encode-flow-table">
        <el-table-column prop="section_name"
                         label="流水段名称">
        </el-table-column>
        <el-table-column prop="pipeline_start"
                         label="开始流水">
        </el-table-column>
        <el-table-column prop="pipeline_end"
                         label="截止流水">
        </el-table-column>
        <el-table-column prop="already_used_num"
                         label="已使用到">
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">

            <el-button @click="deleteFlowSection(scope.row)"
                       type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-group">
        <el-button @click="simulateRule"
                   v-if="curNode.resolve_type==='1' && !isComponent"
                   type="primary">模拟生成</el-button>
        <el-button @click="editRuleSection({},'create')"
                   v-if="curNode.resolve_type==='1' && !isComponent"
                   type="primary">新增规则</el-button>
        <el-button @click="editFlowSection({},'create')"
                   v-if="curNode.resolve_type==='2' && !isComponent"
                   type="primary">新增流水段</el-button>
      </div>
    </div>
    <EditRuleSectionDialog @callback="editRuleCb"
                           :dialogVisible.sync="editRuleDialogVisible"
                           :dialogForm="editRuleDialogForm"
                           :dialogStatus="editRuleDialogStatus"></EditRuleSectionDialog>
    <EditFlowSectionDialog @callback="editFlowCb"
                           :dialogVisible.sync="editFlowDialogVisible"
                           :dialogStatus="editFlowDialogStatus"
                           :dialogForm="editFlowDialogForm"></EditFlowSectionDialog>
    <SimulateRuleDialog :dialogVisible.sync="simulateDialogVisible"
                        :dialogForm="simulateDialogForm"></SimulateRuleDialog>
  </div>
</template>
<script>
import EncodeTree from '@/components/EncodeTree/EncodeTree'
import CompanySelect from '@/components/CompanySelect/CompanySelect'
import { EncodeRuleApi } from '@/services/EncodeRule'
import EditRuleSectionDialog from './components/EditRuleSectionDialog'
import EditFlowSectionDialog from './components/EditFlowSectionDIalog'
import SimulateRuleDialog from './components/SimulateRuleDialog'
export default {
  data () {
    return {
      // 请求编码树参数
      getEncodeTreeParam: {
        type: 2,
        company_id: 0
      },
      // 树形数据
      treeData: [],
      // 当前选中节点
      curNode: {},
      // 规则表数据
      encodeRuleList: {
        list: [],
        total_count: 0,
        total_page: 0
      },
      // 编辑规则段弹框是否可见
      editRuleDialogVisible: false,
      // 编辑规则段弹框数据对象
      editRuleDialogForm: {},
      // 编辑规则段弹框状态
      editRuleDialogStatus: 'create',
      // 获取规则段列表参数
      getRuleSectionParam: {
        rule_code_resolve_id: '',
        page: 1,
        is_page: 0
      },
      // 获取流水段列表参数
      getFlowListParam: {

      },
      // 流水段列表数据
      flowList: {
        list: [],
        total_count: 0,
        total_page: 0
      },
      // 编辑流水段弹框是否可见
      editFlowDialogVisible: false,
      // 编辑流水段弹框数据对象
      editFlowDialogForm: {},
      // 编辑流水端弹框状态
      editFlowDialogStatus: 'create',
      // 模拟生成弹框是否可见
      simulateDialogVisible: false,
      // 模拟生成弹框数据对象
      simulateDialogForm: {}
    }
  },
  name: 'encodeRule',
  components: {
    EncodeTree,
    CompanySelect,
    EditRuleSectionDialog,
    EditFlowSectionDialog,
    SimulateRuleDialog
  },
  props: {
    // 是否作为组件
    isComponent: {
      type: Boolean,
      default: false
    },
    // 当作为组件时，company_id由外部传入
    companyId: {
      type: String,
      default: ''
    }
  },
  watch: {
    curNode: {
      handler (newval) {
        console.log(newval, 'watch encode')
        if (newval.rule_code_resolve_id) {
          if (newval.resolve_type === '1') {
            this.getEncodeTreeParam.rule_code_resolve_id = newval.rule_code_resolve_id
            this.getRuleSectionList()
          } else {
            this.getFlowListParam.rule_code_resolve_id = newval.rule_code_resolve_id
            this.getFlowList()
          }
        } else {
          this.encodeRuleList = {
            list: [],
            total_count: 0,
            total_page: 0
          }
          this.flowList = {
            list: [],
            total_page: 0,
            total_count: 0
          }
        }
      },
      deep: true
    },
    companyId (newval) {
      console.log(newval, 'watch company id')
      if (newval) {
        this.getEncodeTreeParam.company_id = newval
        this.getEncodeTreeData()
      }
    },
    isComponent (newval) {
      console.log(newval, 'is component')
    }
  },
  methods: {
    test (scope) {
      console.log(scope)
    },
    // 选择单位回调
    choosedCompany (data) {
      console.log(data, 'encode rule')
      this.getEncodeTreeParam.company_id = data.company_id
      this.getEncodeTreeData()
    },
    // 获取编码树数据
    getEncodeTreeData () {
      EncodeRuleApi.getEncodeTree({
        params: this.getEncodeTreeParam
      }).then(res => {
        console.log(res, 'get encode tree')
        if (res.code === 0) {
          this.treeData = [
            {
              id: '0',
              name: '编码规则',
              children: res.data
            }
          ]
        }
      }, err => {
        console.log(err)
      })
    },
    // 新增或修改规则段
    editRuleSection (data, status) {
      if (!this.curNode.rule_code_resolve_id) {
        this.$message.warning('请选择规则')
      } else {
        data.rule_code_resolve_id = this.curNode.rule_code_resolve_id
        data.company_id = this.curNode.company_id
        this.editRuleDialogForm = data
        this.editRuleDialogStatus = status
        this.editRuleDialogVisible = true
      }
    },
    // 删除规则段
    deleteRuleSection (data) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRuleSectionApi(data.rule_code_id)
      }).catch(() => {

      })
    },
    // 调用删除规则段api
    deleteRuleSectionApi (id) {
      console.log(id)
      EncodeRuleApi.deleteRuleSection({
        data: {
          rule_code_id: id
        }
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除规则段成功')
          this.getRuleSectionList()
        }
      })
    },
    // 获取规则段列表
    getRuleSectionList () {
      EncodeRuleApi.getRuleSectionList({
        params: this.getEncodeTreeParam
      }).then(res => {
        if (res.code === 0) {
          this.encodeRuleList = res.data
        }
      })
    },
    // 编辑规则段成功回调
    editRuleCb (data) {
      this.getRuleSectionList()
    },
    // 获取流水段列表
    getFlowList () {
      EncodeRuleApi.getFlowList({
        params: this.getFlowListParam
      }).then(res => {
        if (res.code === 0) {
          this.flowList = res.data
        }
      }, err => {
        console.log(err)
      })
    },
    // 编辑流水段
    editFlowSection (data, status) {
      data.rule_code_resolve_id = this.curNode.rule_code_resolve_id
      this.editFlowDialogForm = data
      this.editFlowDialogStatus = status
      this.editFlowDialogVisible = true
    },
    // 编辑流水段成功回调
    editFlowCb () {
      this.getFlowList()
    },
    // 删除流水段
    deleteFlowSection (data) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFlowSectionApi(data.pipeline_section_id)
      }).catch(() => {

      })
    },
    // 调用删除流水段api
    deleteFlowSectionApi (id) {
      EncodeRuleApi.deleteFlowSection({
        data: {
          pipeline_section_id: id
        }
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除流水段成功')
          this.getFlowList()
        }
      }, err => {
        console.log(err)
      })
    },
    // 模拟生成规则
    simulateRule () {
      console.log(this.curNode, 'test')
      this.simulateDialogForm = {
        rule_code_resolve_id: this.curNode.rule_code_resolve_id,
        rule_name: this.curNode.name
      }
      this.simulateDialogVisible = true
    },
    // 模拟生成回调
    simulateCb (data) {

    }
  },
  created () {

  },
  mounted () {

  }
}
</script>
<style scoped lang='scss'>
.encode-rule-container {
  height: 100%;
  padding: 20px;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  .table-container {
    margin-left: 20px;
    width: 80%;
    .btn-group {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SettingManage/EncodeRule.vue